import { NavLink } from "react-router-dom";

function SidebarIcon({ icon }) {
  if (icon === "dashboard") {
    return (
      <svg viewBox="0 0 24 24">
        <path d="M3 13h8V3H3v10zm10 8h8V3h-8v18zM3 21h8v-6H3v6z" />
      </svg>
    );
  }

  if (icon === "calls") {
    return (
      <svg viewBox="0 0 24 24">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    );
  }

  if (icon === "outbound") {
    return (
      <svg viewBox="0 0 24 24">
        <path d="M20 15.92v3a2 2 0 0 1-2.18 2 17.8 17.8 0 0 1-7.63-2.87 17.5 17.5 0 0 1-5.22-5.22A17.8 17.8 0 0 1 2.11 5.18 2 2 0 0 1 4.11 3h2.77a2 2 0 0 1 1.94 1.53c.17.72.44 1.41.8 2.06a2 2 0 0 1-.45 2.11l-1.2 1.2a14 14 0 0 0 6.13 6.13l1.2-1.2a2 2 0 0 1 2.11-.45c.65.36 1.34.63 2.06.8A2 2 0 0 1 20 15.92z" />
      </svg>
    );
  }

  if (icon === "analytics") {
    return (
      <svg viewBox="0 0 24 24">
        <path d="M4 19h16M7 16V9m5 7V5m5 11v-4" />
      </svg>
    );
  }

  if (icon === "leads") {
    return (
      <svg viewBox="0 0 24 24">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m18 0v-2a4 4 0 0 0-3-3.87M15 3.13a4 4 0 0 1 0 7.75M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
      </svg>
    );
  }

  if (icon === "appointments") {
    return (
      <svg viewBox="0 0 24 24">
        <path d="M8 2v4M16 2v4M3 10h18M5 5h14a2 2 0 0 1 2 2v12H3V7a2 2 0 0 1 2-2zm4 8 2 2 4-4" />
      </svg>
    );
  }

  if (icon === "team") {
    return (
      <svg viewBox="0 0 24 24">
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M16 3.13a4 4 0 0 1 0 7.75M23 21v-2a4 4 0 0 0-3-3.87M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
      </svg>
    );
  }

  if (icon === "followup") {
    return (
      <svg viewBox="0 0 24 24">
        <path d="M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
      </svg>
    );
  }

  if (icon === "settings") {
    return (
      <svg viewBox="0 0 24 24">
        <path d="M12 3v2.25M12 18.75V21M4.93 4.93l1.59 1.59M17.48 17.48l1.59 1.59M3 12h2.25M18.75 12H21M4.93 19.07l1.59-1.59M17.48 6.52l1.59-1.59M12 15.75A3.75 3.75 0 1 0 12 8.25a3.75 3.75 0 0 0 0 7.5z" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24">
      <path d="M4 7h16M4 12h10M4 17h16" />
    </svg>
  );
}

export default function SidebarItem({ item, collapsed }) {
  return (
    <NavLink
      to={item.to}
      className={({ isActive }) =>
        `sidebar-item ${isActive ? "active" : ""} ${collapsed ? "collapsed" : ""}`.trim()
      }
      title={collapsed ? item.label : undefined}
      aria-label={item.label}
    >
      <span className="sidebar-active-bar" aria-hidden="true" />
      <span className="sidebar-icon" aria-hidden="true">
        <SidebarIcon icon={item.icon} />
      </span>
      <span className="sidebar-label">{item.label}</span>
    </NavLink>
  );
}
